<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.auditList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.setting.auditList')}}  ({{ pagination.total }})</div>
                        <div class="text-right">
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>
                    <div class="card-body">
                        <form role="form">
                          <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>Entity</label>
                                    <v-select
                                        @input="searchAudit"
                                        
                                        :options="options"
                                        v-model="search.auditable_type"
                                        :value="search.auditable_type ? search.auditable_type.value : ''"
                                      ></v-select>
                                    
                                    
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                  <label>{{ $t("form.setting.auditIt") }}</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    @keyup="searchAudit"
                                   v-model="search.id"
                                    
                                  />
                                </div>
                              </div>
                              <div class="col-sm-3">
                                <div class="form-group">
                                  <label>{{ $t("form.setting.field") }}</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    @keyup="searchAudit"
                                   v-model="search.field"
                                    
                                  />
                                </div>
                              </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label>{{ $t("form.setting.oldValue") }}</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  @keyup="searchAudit"
                                 v-model="search.old_values"
                                  
                                />
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label>{{ $t("form.setting.newValue") }}</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  @keyup="searchAudit"
                                  v-model="search.new_values"
                                  
                                />
                              </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{ $t("form.setting.event") }}</label>
                                  <select class="form-control" v-model="search.event" @change="searchAudit">
                                    <option value="">Please Select Event</option>
                                    <option value="created">Created</option>
                                    <option value="updated">Updated</option>
                                  </select>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                  <label>{{ $t("form.setting.changedBy") }}</label>
                                  
                                <v-select
                                    v-model="selectedUser"
                                    :options="searchResults"
                                    label="name"
                                    @search="searchUser"
                                    @input="onUserSelected"
                                    placeholder="Search User ..." 

                                    
                                >
                                </v-select>
                                </div>
                              </div>

                              <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{ $t("form.setting.date") }}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    v-model="search.dateRange"
                                    ref="dateRangeInput"
                                  />
                                  <div class="input-group-append">
                                    <span class="input-group-text">
                                      <i class="fas fa-times" @click="clearDateRange"></i>
                                    </span>
                                  </div>

                                  
                                </div>
                              </div>
                          </div>
                        </form>
                      </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="audits.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.setting.entity')}}</th>
                                    <th>{{$t('form.setting.id')}}</th>
                                    <th>{{$t('form.setting.field')}}</th>
                                    <th>{{$t('form.setting.oldValue')}}</th>
                                    <th>{{$t('form.setting.newValue')}}</th>
                                    <th>{{$t('form.setting.event')}}</th>
                                    <th>{{$t('form.setting.changedBy')}}</th>
                                    <th>{{$t('form.setting.timeStamp')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(audit , index) in audits" :key="index">
                                    <td>{{audit.type}}</td>
                                    <td>{{audit.ID}}</td>
                                    <td>{{audit.field}}</td>
                                    <td>{{audit.oldValue}}</td>
                                    <td>{{audit.newValue}}</td>
                                    <td>{{audit.event}}</td>
                                    <td>{{audit.userName}}</td>
                                    <td>{{audit.createdAt | formatDate(datetimeFormat)}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3" v-else>{{$t('noRecord')}}</p>
                    </div>

                    <!-- Pagination -->
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" @paginate="paginate()"
                        :offset="5">
                    </pagination>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import 'daterangepicker/daterangepicker.css';
import 'daterangepicker';
import vSelect from 'vue-select';

    export default {
        props: ['permissions', 'datetimeFormat'],
        components: {
            vSelect,
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                cancelTokenSource: null,
                cancelTokenSourceU: null,
                searchQuery: '',
                searchResults: [],
                selectedUser: null,
                cancelToken: null,
                pagination: {
                    current_page: 1
                },
                dateRangePickerInstance: null,
                
                audits: [],
                status:null,
                options: [
                    { label: 'Select an option', value: "", disabled: true },

                    { label: 'Alumni', value: 'App\\Student\\Alumni' },
                    { label: 'Grade', value: 'App\\Student\\Grade' },
                    { label: 'Grade2', value: 'App\\Student\\Grade2' },
                    { label: 'Program', value: 'App\\Program' },
                    { label: 'Company', value: 'App\\Company' },
                    { label: 'Book', value: 'App\\Book' },
                    { label: 'Course', value: 'App\\Course' },
                    
                   
                    { label: 'Attachment', value: 'App\\Attachment' },
                    { label: 'Business', value: 'App\\Student\\Business' },
                    { label: 'Graduation Requirement', value: 'App\\Student\\GraduationReq' },
                    { label: 'Student', value: 'App\\Student\\Student' },
                    { label: 'StudentProgram', value: 'App\\Student\\StudentProgram' },
                    
                    { label: 'Student Status', value: 'App\\Student\\StudentStatus' },
                    { label: 'StudentAbsence', value: 'App\\Student\\StudentAbsence' },
                    { label: 'Admission', value: 'App\\Student\\Admission' },
                    { label: 'Application', value: 'App\\Student\\Application' },
                    { label: 'Absence', value: 'App\\Student\\StudentAbsence' },
                    { label: 'Invoice', value: 'App\\Invoice' },
                    { label: 'User', value: 'App\\User' },
                ],
                search:{
                    new_values: "",
                    old_values:"",
                    event:"", 
                    auditable_type: "",
                    dateRange: '',
                    id:null,
                    changed_by:null
                }
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsAudits) {
                return this.$router.push('/');
            }

            let self = this;
            self.getAllStatus().then(function(result) {
                self.getAudits();
            });
            //Date Range
            this.initializeDateRangePicker();
           

            document.querySelectorAll('.vs__clear').forEach(button => {
                button.addEventListener('click', this.handleClearClick);
            });
        },

        watch: {
            search: {
                handler(newSearch) {const emojiRegex = /[\u{10000}-\u{10FFFF}]/gu;
                    
                    // Loop through all properties in the search object
                    Object.keys(newSearch).forEach(key => {
                    // Only process string values
                    if (typeof newSearch[key] === 'string' && emojiRegex.test(newSearch[key])) {
                        // Strip the emoji and update the reactive property
                        this.search[key] = newSearch[key].replace(emojiRegex, '');
                    }
                    });
                },
                deep: true  
            }
        },

        methods: {
                // Clear search input fields
            clearSearch() {
                this.search = {
                    new_values: "",
                    old_values:"",
                    event:"", 
                    auditable_type: "",
                    dateRange: '',
                    id:null,
                    changed_by:null
                };

                this.searchAudit();
            },

            initializeDateRangePicker() {
                this.dateRangePickerInstance = $(this.$refs.dateRangeInput).daterangepicker({
                    opens: 'left',
                    locale: {
                    format: 'YYYY-MM-DD',
                    },
                }, (start, end) => {
                    this.search.dateRange = `${start.format('YYYY-MM-DD')} - ${end.format('YYYY-MM-DD')}`;
                    this.search.startDate = start.format('YYYY-MM-DD');
                    this.search.endDate = end.format('YYYY-MM-DD');
                    this.searchAudit();
                });
                // Add an event listener to trigger searchAudit when the date range is applied
                this.dateRangePickerInstance.on('apply.daterangepicker', (ev, picker) => {
                    this.searchAudit();
                });
            },

            clearDateRange() {
               // Destroy the existing date range picker instance if it exists
               
                 // Clear the input value
                this.$refs.dateRangeInput.value = '';

                // Unbind any event handlers associated with the date picker
                $(this.$refs.dateRangeInput).off();

                // Initialize the date range picker
                this.initializeDateRangePicker();

                // Clear the search dates
                this.search.startDate = null;
                this.search.endDate = null;
                this.search.dateRange = null;

                // Update the search and trigger the audit function
                this.searchAudit();
            },

            searchUser(query) {
                // Cancel the previous request if it exists
                if (this.cancelTokenSourceU) {
                    this.cancelTokenSourceU.cancel('Operation canceled by the user.');
                }

                // Create a new CancelToken source
                this.cancelTokenSourceU = axios.CancelToken.source();

                // Perform the API call only if the query is not empty
                if (query.trim() !== '') {
                    axios.get(`/api/users/search?query=${query}`, {
                    cancelToken: this.cancelTokenSourceU.token,
                    })
                    .then(response => {
                        this.searchResults = response.data;
                    })
                    .catch(error => {
                        if (axios.isCancel(error)) {
                            console.log('Request canceled:', error.message);
                        } else {
                            console.error('Error searching users', error);
                        }
                    });
                } else {
                    this.searchResults = [];
            }
            },
            onUserSelected(selectedUser) {
                // Handle the selected user
                this.selectedUser = selectedUser;

                // Extract user ID and perform any additional logic
                if (selectedUser) {
                    this.search.changed_by = selectedUser.id; // Assuming your user object has an 'id' property
                    this.buildQueryString(this.search);
                    this. getAudits() ;
                }
            },
        
            handleClearClick() {
                  // Handle the event when the user clears the selected value
                this.selectedUser = null;
                this.search.changed_by = null;
                this.buildQueryString(this.search);
                this. getAudits() ;
                console.log (this.buildQueryString(this.search));
            },
  
            searchAudit(){
                this.pagination.current_page =1;
                this. getAudits() ;

            },
            getAllStatus() {
                let self = this;
                return new Promise(function(resolve, reject) {
                axios.get('/api/config')
                .then(response => {
                if (response.data) {
                    let config = response.data;
                    self.status = config.status;
                    }
                })
                resolve('Successfully got all status');
                });
                
               
            },
            getAudits() {
                this.isLoading = true;
               // Cancel the previous request if it exists
                if (this.cancelTokenSource) {
                    this.cancelTokenSource.cancel('Previous request cancelled');
                }

                // Create a new cancel token source
                const cancelTokenSource = axios.CancelToken.source();
                this.cancelTokenSource = cancelTokenSource;


                let filters = this.buildQueryString(this.search);
                let page = this.pagination.current_page;

                axios.get(`/api/audits?page=${page}${filters}` , {
                        // Pass the cancel token to the request
                        cancelToken: cancelTokenSource.token,
                    })
                    .then(response => {
                        this.audits = response.data.data;
                        this.audits.map(audit => {                          
                            if(audit.field == 'Status'){
                            var newValue = Object.keys(this.status).find(key => this.status[key] == audit.newValue);
                            audit.newValue = newValue;
                            var oldValue = Object.keys(this.status).find(key => this.status[key] == audit.oldValue);
                            audit.oldValue = oldValue;
                            }
                        });
                        this.pagination = response.data.pagination;

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (axios.isCancel(error)) {
                            // Request was cancelled
                            console.log('Request cancelled', error.message);
                        } else {
                            // Handle other errors
                            this.isLoading = false;
                        }
                    });
                },
                

            paginate() {
                this.getAudits();
            },
            buildQueryString(search) {
                let queryString = '';

                for (let key in search) {
                    if (key === 'auditable_type' && search[key]) {
                        queryString += `&${key}=${encodeURIComponent(search[key].value)}`;
                    }
                    else
                     if (search[key]) {
                        queryString += `&${key}=${encodeURIComponent(search[key])}`;
                    }
                }

                return queryString;
            },
        }
    }

</script>
